import { IAuthState } from "./authSlice.types";
import { createSlice } from "@reduxjs/toolkit";

const initialState: IAuthState = {
    token: null,
    merchantLoggedIn: false,
    activeTab: 'Dashboard',
    activeDropDownTab: '',
    activeDropDown: null,
    collapsed: false,
};

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login(state, action) {
            state.token = action.payload.accessToken;
            state.merchantLoggedIn = true;
        },
        logout(state) {
            state.token = null;
            state.merchantLoggedIn = false;
            state.activeTab = 'Dashboard';
            state.activeDropDownTab = '';
            state.activeDropDown = null;
            state.collapsed = false;
        },
        setActiveTab(state, action) {
            state.activeTab = action.payload;
        },
        setCollapseSidebar(state, action) {
            state.collapsed = action.payload;
        },
        setActiveDropDownTab(state, action) {
            state.activeDropDownTab = action.payload;
        },
        setActiveDropDown(state, action) {
            state.activeDropDown = action.payload;
        },
    },
});

const authReducer = authSlice.reducer;
export const selectAuth = (state: any) => state.auth;
export const selectActiveTab = (state: any) => state.auth.activeTab;
export const selectActiveDropDownTab = (state: any) => state.auth.activeDropDownTab;
export const selectActiveDropDown = (state: any) => state.auth.activeDropDown;
export const selectCollapsedSidebar = (state: any) => state.auth.collapsed;

export const { login, logout, setActiveTab, setCollapseSidebar, setActiveDropDownTab, setActiveDropDown } = authSlice.actions;
export default authReducer;
